import type { DefaultOptions } from "@tanstack/react-query";

// Prevent fetching too soon after the first successful request.
export const DEFAULT_STALE_TIME = 8000;

export const defaultOptions: DefaultOptions = {
  queries: {
    staleTime: DEFAULT_STALE_TIME,
    refetchOnWindowFocus: false,
    retry: false, // Prevent refetching everytime a query fails, will do manually when needed
    retryOnMount: false,
  },
};
